// src/menu/sections/projectMenu.ts
import type { AppMenuEntry } from "../types";

export const PROJECT_MENU: AppMenuEntry = {
  type: "group",
  key: "project",
  label: "Project",
  children: [
    {
      key: "Projectcontrol",
      label: "ProjectControl",
      path: "/project_control",
      componentKey: "projectControl",
      icon: "project",
    },
    {
      key: "tasks",
      label: "Tasks",
      path: "/tasks",
      resource: "tasks",
      icon: "todos",
    },
    /*
    {
      key: "projects",
      label: "Projects",
      path: "/projects",
      resource: "projects",
      icon: "home",
    },
    {
      key: "task_comments",
      label: "Task Comments",
      path: "/task_comments",
      resource: "task_comments",
      icon: "home",
    },
    {
      key: "task_relations",
      label: "Task Relations",
      path: "/taks_relations",
      resource: "task_relations",
      icon: "home",
    },
    {
      key: "project_shares",
      label: "Project Shares",
      path: "/project_shares",
      resource: "project_shares",
      icon: "home",
    },
    {
      key: "task_shares",
      label: "Task Shares",
      path: "/task_shares",
      resource: "task_shares",
      icon: "home",
    },
*/
    {
      key: "task_status_history",
      label: "Task Status History",
      path: "/task_status_history",
      resource: "task_status_history",
      icon: "history",
    },
  ],
};
